import 'epion-checkin/i18n/config';
import { QueryClientProvider } from '@tanstack/react-query';
import { SchedulerErrorBoundary } from 'components/error-boundary/error-boundary';
import { AppOptionsContextProvider } from 'contexts/app-options';
import { EpionCheckIn } from 'epion-checkin';
import { ErrorBoundaryFallback } from 'epion-checkin/components/error-boundary-fallback';
import { CaptureCountlyEventsContextProvider } from 'epion-checkin/context/capture-countly-events';
import { ThemeProvider } from 'epion-checkin/theme/theme-provider';
import { queryClient } from 'modules/react-query';
import { FC } from 'react';
import { EpionCheckinAppOptions } from 'types';

interface Props {
    options: EpionCheckinAppOptions;
}

export const EpionCheckInRoot: FC<Props> = ({ options }) => {
    return (
        <ThemeProvider>
            <CaptureCountlyEventsContextProvider departmentId={options.departmentId}>
                <AppOptionsContextProvider options={options}>
                    <QueryClientProvider client={queryClient}>
                        <SchedulerErrorBoundary fallbackComponent={ErrorBoundaryFallback}>
                            <EpionCheckIn options={options} />
                        </SchedulerErrorBoundary>
                    </QueryClientProvider>
                </AppOptionsContextProvider>
            </CaptureCountlyEventsContextProvider>
        </ThemeProvider>
    );
};
